import { jsonMember, jsonObject } from 'typedjson';
import { PublicBoxStatusType } from '../../enums/public-box-status-type';

@jsonObject
export class PublicBoxVisibilityResponse {
  @jsonMember(String)
  public id!: string;

  @jsonMember(String)
  public status!: PublicBoxStatusType;
}
